module.exports = __webpack_public_path__ + "static/media/person_icon.ce6cb6d0.svg";